// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__6XL3A","content":"Modal_content__oJU2M"};